import { render, staticRenderFns } from "./DefaultV2Table.vue?vue&type=template&id=c489cc4a&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./DefaultV2Table.vue?vue&type=script&lang=js"
export * from "./DefaultV2Table.vue?vue&type=script&lang=js"
import style0 from "./DefaultV2Table.vue?vue&type=style&index=0&id=c489cc4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c489cc4a",
  null
  
)

export default component.exports